import React from 'react';
import { Navbar } from '../components';

interface PageLayoutProps {
  children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <div className="font-primary min-h-screen text-neutral-900">
      <Navbar />
      <main className="relative">{children}</main>
    </div>
  );
};
